import { render, staticRenderFns } from "./DeleteTemplateModal.vue?vue&type=template&id=2afed4b0&"
import script from "./DeleteTemplateModal.vue?vue&type=script&lang=js&"
export * from "./DeleteTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports